import * as _ from "lodash";

export const assetSelector = (asset: any, ids: string[], elementId = "") => {
  const fields = asset ? [asset.json] : asset

  if(elementId && fields) {
    return getFieldById(fields, elementId, "fields")
  }

  if (fields) {
    let field = fields;
    let resFind: any;
    let id = "";

    _.each(ids, (value, key) => {
      id += key === 0 ? value : "#" + value;
      const find = _.find(field, ["id", id.trim()]);
      if (find) {
        field = find.fields;
        if (find.id === ids.join("#")) {
          resFind = find;
        }
      }
    });

    return resFind;
  }

  return {};
};


const getFieldById = (form: any[], elementId: string, nestingKey: string): any => {
  // eslint-disable-next-line
  const field = form.reduce((a, item) => {
    if (a) return a;
    if (item.elementId === elementId) return item;
    if (item[nestingKey])
      return getFieldById(item[nestingKey], elementId, nestingKey);
  }, null);

  return field;
}
